// extracted by mini-css-extract-plugin
module.exports = {"photo":"ServiceSingle_photo__2y78o","info":"ServiceSingle_info__CVqHC","step":"ServiceSingle_step__2JNf1","wrapper":"ServiceSingle_wrapper__3g-f1"};